<template>
  <div
    v-loading="isShow"
    element-loading-text="正在分析中..."
    element-loading-spinner="el-icon-loading"
  ></div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
/deep/.el-loading-mask {
  position: fixed;
  z-index: 10000;
  background-color: rgba(255, 255, 255, 0.9);
  margin: 0;
  top: 60px;
  right: 480px;
  bottom: 0;
  left: 0;
  transition: opacity 0.3s;
}
</style>
